import { Card } from "@/shared/components/ui/card";
import { useVbsLMRAShowQuery } from "@/services/backend/vbs/work-orders/api/lmra-api";
import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { ConfirmedLMRAComponent } from "@/services/backend/vbs/work-orders/components/confirmed-lmra";
import { UnconfirmedLMRAComponent } from "@/services/backend/vbs/work-orders/components/unconfirmed-lmra";
import { useVbsWorkOrderShowQuery } from "@/services/backend/vbs/work-orders/api/work-order-api";
import t from "@/lang/lang";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

export function WorkOrderCompletionLmraRoute() {
  const { lmraId, workOrderId } = useParams();
  const { data: workOrder } = useVbsWorkOrderShowQuery({ id: workOrderId! });
  const {
    data: lmra,
    isLoading,
    error,
  } = useVbsLMRAShowQuery({
    id: lmraId!,
  });

  if (isLoading) {
    return (
      <Card className="text-muted-foreground animate-pulse p-6">
        {t("Lade Daten...")}
      </Card>
    );
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!lmra) return null;

  if (lmra.confirmed) {
    return (
      <ConfirmedLMRAComponent
        lmra={lmra}
        disabled={workOrder !== undefined && isImmutable(workOrder)}
      />
    );
  }
  return (
    <UnconfirmedLMRAComponent
      lmra={lmra}
      disabled={workOrder !== undefined && isImmutable(workOrder)}
    />
  );
}
